import React from 'react';
import { Box, Chip } from '@mui/material';
import { useListPropertyContext } from '../../../../../contexts/ListPropertyContext';
import { listingSectionStyles } from '../ListingSection.styles';
import residentialIcon from '../../../../../assets/Residential.png';
import apartmentIcon from '../../../../../assets/Apartment.png';
import villaIcon from '../../../../../assets/Villa.png';

const propertyTypes = [
  { id: 'residential', label: 'Residential', icon: residentialIcon },
  { id: 'apartment', label: 'Apartment', icon: apartmentIcon },
  { id: 'villa', label: 'Villa', icon: villaIcon },
];

const PropertyTypeChips = () => {
  const { formData, updateFormData } = useListPropertyContext();
  const styles = listingSectionStyles;

  const handleChipClick = (typeId) => {
    updateFormData('propertyType', formData.propertyType === typeId ? null : typeId);
  };

  return (
    <Box sx={styles.chipsContainer}>
      {propertyTypes.map((type) => {
        const isSelected = formData.propertyType === type.id;
        return (
          <Chip
            key={type.id}
            icon={
              <Box
                component="img"
                src={type.icon}
                alt={type.label}
                loading="lazy"
                sx={styles.chipIcon}
              />
            }
            label={type.label}
            onClick={() => handleChipClick(type.id)}
            sx={isSelected ? styles.chipSelected : styles.chipDefault}
          />
        );
      })}
    </Box>
  );
};

export default PropertyTypeChips;

